import React from 'react';

import { DirectoryList } from '@/components/_common/directory';
import { routes } from '@/config';

import { ROLE } from '../../constants';
import { useSerpsMatch } from '../../hooks/use-serps-match';
import { Breadcrumb } from '../breadcrumb';
import { RelatedJobs } from '../related-jobs';
import { SalaryData } from '../salary-data';
import { SeoCopies } from '../seo-copies';
import { ServicesList } from '../services-list';
import { TopCategories } from '../top-categories';
import { TopCitiesSkills } from '../top-cities-skills';
import { TopSubcategories } from '../top-subcategories';

import * as S from './serps-container.styles';

export const SerpsContainer: React.VFC = () => {
  const serps = useSerpsMatch();

  const subcategories = serps?.subcategory ? null : <TopSubcategories />;
  const isJobRoleSerp = serps?.category === ROLE && serps?.subcategory === undefined;

  return (
    <S.GridContainer>
      <Breadcrumb />

      {isJobRoleSerp ? (
        <>
          <SalaryData />
          <RelatedJobs />
          <TopCitiesSkills />
        </>
      ) : null}
      <SeoCopies />
      {subcategories}
      <TopCategories />
      <ServicesList />
      <DirectoryList titleTranslationKey="XJM_SEO_DIRECTORY_PAGINATION_H" isSerpsView route={routes.jobsDirectory} />
      <DirectoryList
        titleTranslationKey="COMPANY_DIRECTORY_LIST_H"
        isSerpsView
        route={routes.companiesDirectory}
        allowOthersRoute
      />
    </S.GridContainer>
  );
};
